import(/* webpackMode: "eager" */ "C:\\Users\\a.carasi\\StudioProjects\\web-maker-admin-2\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\a.carasi\\StudioProjects\\web-maker-admin-2\\src\\app\\App.css");
;
import(/* webpackMode: "eager" */ "C:\\Users\\a.carasi\\StudioProjects\\web-maker-admin-2\\src\\app\\index.css");
